/**
 * アンカーリンク関連の処理
 */
export default class Contact {
    constructor() {
        this.completeToggle();
        this.inputEnterInvalid();
    }
    completeToggle() {
        $('.js-item-toggle').on('click', function () {
            $(this).next('.js-item-target').slideToggle()
        });
    }

    inputEnterInvalid() {
        $("input").on("keydown", function (e) {
            if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                return false;
            } else {
                return true;
            }
        });
    }
}
